setTimeout(function () {
  // add button role to divs, spans, and anchors with onclick handlers
  document.querySelectorAll('div[onclick], span[onclick], a[onclick]').forEach(el => {
    if (!el.hasAttribute('role')) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
    }
  });

  // add button role to stamped badges
  document.querySelectorAll('.stamped-badge').forEach(el => {
    const computedStyle = window.getComputedStyle(el);
    const isVisiblyClickable = computedStyle.cursor === 'pointer' || el.onclick || el.getAttribute('aria-label');

    if (!el.hasAttribute('role') && isVisiblyClickable) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
    }
  });

  // Add aria-labels to otto-slider arrows and dots if missing
  document.querySelectorAll('.otto-slider__arrow').forEach(el => {
    if (!el.hasAttribute('aria-label')) {
      const dir = el.getAttribute('data-direction');
      if (dir === 'prev') el.setAttribute('aria-label', 'Previous slide');
      else if (dir === 'next') el.setAttribute('aria-label', 'Next slide');
    }
  });

  // Add aria-labels to otto-slider dots and aria-current to active dot
  document.querySelectorAll('.otto-slider__dot').forEach((el, i) => {
    if (!el.hasAttribute('aria-label')) {
      el.setAttribute('aria-label', `Go to slide ${i + 1}`);
    }
    if (el.classList.contains('active')) {
      el.setAttribute('aria-current', 'true');
    } else {
      el.removeAttribute('aria-current');
    }
  });

  // Add aria-label to links that open in a new tab if missing
  document.querySelectorAll('a[target="_blank"]').forEach(link => {
    const label = link.getAttribute('aria-label');
    const title = link.getAttribute('title');
    const hasScreenReaderNote = link.innerHTML.includes('sr-only') || label?.includes('new tab');

    if (!hasScreenReaderNote) {
      const desc = title || link.textContent?.trim() || 'link';
      link.setAttribute('aria-label', `${desc} (opens in a new tab)`);
    }
  });

  // Add aria-label to price items if missing
  document.querySelectorAll('s.price-item--regular').forEach(el => {
    if (!el.hasAttribute('aria-label')) {
      const priceText = el.textContent.trim();
      el.setAttribute('aria-label', `Original price ${priceText}`);
    }
  });

  // Ensure font size is at least 12px for stamped review dates and links
    document.querySelectorAll('.stamped-reviews-date, .stamped-reviews-link, .stamped-style-color-link').forEach(el => {
      console.log('Checking font size for', el);
      const computedSize = parseFloat(window.getComputedStyle(el).fontSize);
      console.log('Computed font size:', computedSize);
      if (computedSize <= 11) {
        el.style.fontSize = '12px';
        el.style.lineHeight = '1.3';
      }
    });

    // Add aria-labels to stamped carousel buttons if missing
    const leftBtn = document.querySelector('.stamped-carousel-button-left');
    const rightBtn = document.querySelector('.stamped-carousel-button-right');

    if (leftBtn && !leftBtn.hasAttribute('aria-label')) {
      leftBtn.setAttribute('aria-label', 'Previous review');
    }

    if (rightBtn && !rightBtn.hasAttribute('aria-label')) {
      rightBtn.setAttribute('aria-label', 'Next review');
    }

}, 2500);

setTimeout(function () {

  // add button role to fsb_background
  const fsb = document.getElementById('fsb_background');
  if (fsb && !fsb.hasAttribute('role')) {
    fsb.setAttribute('role', 'button');
    fsb.setAttribute('tabindex', '0');
  }
}, 4000);